import customAxios from '../../customAxios';

import { LOCATION_NEIGHBORHOOD } from '../../routes';
import { locationNamespace } from '../../../types/location.namespace';

async function createNeighborhood(props: locationNamespace.neighborhood.create) {
  try {
    return (await customAxios.post(LOCATION_NEIGHBORHOOD, props)).data;
  } catch (error: any) {
    console.error({LOCATION_NEIGHBORHOOD: error});
  }
}

export default createNeighborhood;
